import { Button, Select, Container, MenuItem, Fade, FormControl, Grid, InputAdornment, InputLabel, ListItem, makeStyles, Modal, OutlinedInput, Paper, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import Backdrop from '@material-ui/core/Backdrop';
import EditIcon from '@material-ui/icons/Edit';
import { Store } from "react-notifications-component";
import { useDispatch } from "react-redux";
import { createUsers } from '../../domain/api/UsersApi';


//estilos
const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paperModal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '60px',
    marginTop: '-1%',
    marginBottom: '3.2%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default function DatosTablaRegistroUsers({ resultado, nameBascula, year, ListaA, ID, reload, primaryColor }) {

  const classes = useStyles()
  const [, setEvbi] = useState("");
  const [total, setTotal] = useState(resultado.mes);
  const [, setAño] = useState("");
  const [, setFechaC] = useState("");
  const [, setFechaE] = useState("");
  const [Mes, setMes] = useState("");
  const [openEdit, setOpenEdit] = useState(false);

  const dispath = useDispatch()
  const id = ID

  //editar 
  const Editar = () => {
    const Request = {
      evbi: id,
      mes: Mes,
      year: year,
      total: total
    }

    createUsers(dispath, Request).then((response) => {

      if (response.codigo === "0000") {
        Store.addNotification({
          title: "Actualizado Exitosamente!",
          message: `actualizada con exito!`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
        handleCloseEdit()
        reload(id, year)
      } else {
        Store.addNotification({

          message: `${response.mensaje}!`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          },

        });
        handleCloseEdit()
        reload(id, year)
      }



    }).catch((err) => {
      Store.addNotification({
        title: "Error!",
        message: `Error interno ${err}!`,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    })
  }


  //abrir la modal de editar

  const handleOpenEdit = (row) => {
    setMes(row.mes)

    setEvbi(nameBascula)
    setTotal(row.total)
    setAño(row.year)
    setFechaC(row.created);
    setFechaE(row.date_updated)
    setOpenEdit(true);

  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const r = resultado !== undefined && resultado !== null ? resultado : []
  return (
    <>
      {r.map((row) => (
        <Paper key={row.id} className={classes.card}>
          <Grid container spacing={1}>
            <Grid style={{ width: '22%', textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
              {row.mes}
            </Grid>
            <Grid item xs={3} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
              {row.total}
            </Grid>
            <Grid item xs={3} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', paddingLeft: '6%' }}>
              {UtilsDate().formatDDMMMYYYYHHmm(new Date(row.date_updated))}
            </Grid>
            <Grid item xs={3} style={{ width: '10%', marginTop: '-1.2%' }} className={classes.actionsStyles} onClick={() => { handleOpenEdit(row) }}>
              <ListItem button  >
                <Tooltip title="Editar" aria-label="top-end">
                  <EditIcon className={classes.tableAction} style={{ color: primaryColor }} />
                </Tooltip>
              </ListItem>
            </Grid>
          </Grid>
        </Paper>
      ))}
      <div>
        <Modal
          className={classes.modal}
          open={openEdit}
          onClose={handleCloseEdit}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openEdit}>
            <div className={classes.paperModal}>
              <Container>

                <Grid item xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2rem' }}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="totalUsers" shrink style={{ fontWeight: "bold", fontSize: '18px' }}>
                      Total Usuarios*
                    </InputLabel>
                    <OutlinedInput
                      id="totalUsers"
                      style={{ fontSize: '18px', borderRadius: '10px', marginRight: '3%' }}
                      type="total"
                      name='totalUsers'
                      value={total}
                      onChange={(e) => {
                        setTotal(e.target.value);
                      }}
                      startAdornment={<InputAdornment position="start">-</InputAdornment>}
                      label="Total Usuarios"
                      autoComplete='off'
                      classes={{
                        focused: classes.totalUsersInput, // Aplica la clase cuando está enfocado
                      }}
                    />
                  </FormControl>

                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="Mes" style={{ fontWeight: "bold", fontSize: '18px' }}>MES*</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="Mes"
                      name="Mes"
                      value={Mes}
                      style={{ fontSize: '18px', borderRadius: '10px' }}
                      onChange={e => {
                        setMes(e.target.value)
                      }}
                      label="Tipo de actividad"
                      startAdornment={<InputAdornment position="start">-</InputAdornment>}
                      disabled
                    >
                      <MenuItem value="">
                        <em>Seleciona un Mes</em>
                      </MenuItem>
                      <MenuItem value="Enero">ENERO</MenuItem>
                      <MenuItem value="Febrero">FEBRERO</MenuItem>
                      <MenuItem value="Marzo">MARZO</MenuItem>
                      <MenuItem value="Abril">ABRIL</MenuItem>
                      <MenuItem value="Mayo">MAYO</MenuItem>
                      <MenuItem value="Junio">JUNIO</MenuItem>
                      <MenuItem value="Julio">JULIO</MenuItem>
                      <MenuItem value="Agosto">AGOSTO</MenuItem>
                      <MenuItem value="Septiembre">SEPTIEMBRE</MenuItem>
                      <MenuItem value="Octubre">OCTUBRE</MenuItem>
                      <MenuItem value="Noviembre">NOVIEMBRE</MenuItem>
                      <MenuItem value="Diciembre">DICIEMBRE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "center", marginTop: '2rem' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={Editar}
                    disabled={!total || !Mes}
                    style={{ borderRadius: '10px', marginRight: '2%' }}

                  >
                    Guardar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={handleCloseEdit}
                    style={{ borderRadius: '10px' }}

                  >
                    Cancelar
                  </Button>
                </Grid>

              </Container>
            </div>
          </Fade>
        </Modal>

      </div>

    </>
  );
}